<template>
    <div class="FosterDashboardPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-lg-3 col-xl-2">
                    <div class="paper olive-green">
                        <b-nav pills vertical class="side-menu">
                            <b-nav-item v-on:click="ChangePaneShown('Applicants')" v-bind:class="{ active: PanesShown == 'Applicants' }"><font-awesome-icon :icon="['fa', 'list']" /> Power BI Reports</b-nav-item>
                        </b-nav>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-10">
                    <div class="paper">
                        <div class="tab-content col-12">
                            <div v-show="PanesShown == 'Applicants'">
                                <Applicants />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faHome } from '@fortawesome/free-solid-svg-icons';
    library.add(faHome);
    //import components
    import Applicants from "./Applicants.vue";


    export default {
        props: [],
        data: function () {
            return {
                PanesShown: "Applicants"
            };
        },
        methods: {
            ChangePaneShown(paneName) {
                //loop through Panes shown and flip true/false values
                this.PanesShown = paneName;
            }
        },
        computed: {
            
        },
        components: {
            Applicants
        }
    }
</script>

<style scoped>
</style>